import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import GlobalErrorBoundary from './components/ErrorBoundary/GlobalErrorBoundary';
import ComponentErrorBoundary from './components/ErrorBoundary/ComponentErrorBoundary';
import Main from './layouts/Main'; // fallback for lazy pages
import './static/css/main.scss'; // All of our styles

const { PUBLIC_URL } = process.env;

// Every route - we lazy load so that each page can be chunked
// NOTE that some of these chunks are very small. We should optimize
// which pages are lazy loaded in the future.
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Index = lazy(() => import('./pages/Index'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Projects = lazy(() => import('./pages/Projects'));
const Resume = lazy(() => import('./pages/Resume'));
const Stats = lazy(() => import('./pages/Stats'));

const App: React.FC = () => (
  <GlobalErrorBoundary>
    <ThemeProvider>
      <BrowserRouter basename={PUBLIC_URL}>
        <Suspense fallback={<Main />}>
          <Routes>
            <Route
              path="/"
              element={
                <ComponentErrorBoundary componentName="Index">
                  <Index />
                </ComponentErrorBoundary>
              }
            />
            <Route
              path="/about"
              element={
                <ComponentErrorBoundary componentName="About">
                  <About />
                </ComponentErrorBoundary>
              }
            />
            <Route
              path="/projects"
              element={
                <ComponentErrorBoundary componentName="Projects">
                  <Projects />
                </ComponentErrorBoundary>
              }
            />
            <Route
              path="/stats"
              element={
                <ComponentErrorBoundary componentName="Stats">
                  <Stats />
                </ComponentErrorBoundary>
              }
            />
            <Route
              path="/contact"
              element={
                <ComponentErrorBoundary componentName="Contact">
                  <Contact />
                </ComponentErrorBoundary>
              }
            />
            <Route
              path="/resume"
              element={
                <ComponentErrorBoundary componentName="Resume">
                  <Resume />
                </ComponentErrorBoundary>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  </GlobalErrorBoundary>
);

export default App;
